import { IModalStatus } from '@/type/detail';
import { SET_MODAL_STATUS } from './const';

const initState: IModalStatus = {
  isModalShow: false,
};
interface Action {
  type: string;
  payload: IModalStatus;
}

const reducer = (state = initState, { type, payload }: Action) => {
  switch (type) {
    case SET_MODAL_STATUS:
      return { ...state, isModalShow: payload.isModalShow };
  }
  return state;
};

export default reducer;
